 import React, { Component } from "react";
import I18n from "../../../i18n/I18n";
import { Icon, ToggleButton, LocaleLink } from "../../common";
import styles from "./SalesDetails.scss";
import ItemGlobalCard from "./ItemGlobalCard";
import SalesOverview from "./SalesOverview";
import PaymentHistory from "./PaymentHistory";

type Props = {
  item: Object,
  lang: string
};

type State = {
  view: number // 1: sales-overview, 2: payment-history
};

class SalesDetails extends Component<Props, State> {
  state = {
    view: 1
  };

  tabToggle = selected => {
    this.setState({
      view: selected
    });
  };

  render() {
    const { item: salesItem, lang } = this.props;
    const pendingItem = salesItem.item_delivered_scenario;
    const item = salesItem.item_global_status;
    const statements = JSON.parse(JSON.stringify(salesItem.statements)); // assuming it is sorted
    statements.unshift(JSON.parse(JSON.stringify(item)));
    const currencyCode = item.currency_code || "AED";
    const saleData = {
      header: I18n.getText("sales.sale-data"),
      details: [
        { label: I18n.getText("sales.shipped-date"), value: item.shipped_date }
      ]
    };
    let penaltyData = {};
    if (item.sla_code !== "legacy") {
      saleData.details.push(
        {
          label: I18n.getText("sales.return-ndr-due"),
          value: item.return_ndr_due_date || "-"
        },
        {
          label: I18n.getText("sales.return-cir-due"),
          value: item.return_cir_due_date || "-"
        }
      );
      penaltyData = {
        header: I18n.getText("sales.late-return-penalty"),
        details: Object.entries(item)
          .filter(entryEach => entryEach[0].includes("penalty_rate_"))
          .map(entryEach => {
            return { label: entryEach[0].slice(-2), value: entryEach[1] };
          })
      };
    }
    const commissionData = {
      header: I18n.getText("sales.commission-data"),
      details: [
        { label: I18n.getText("sales.sla-type"), value: item.sla_name },
        {
          label: I18n.getText("sales.product-type"),
          value: item.product_fulltype_code
            ? item.product_fulltype_code
                .replace(/\./g, " ")
                .replace(/_/g, " / ")
            : ""
        },
        {
          label: I18n.getText("sales.commission-type"),
          value: item.commission_name
        },
        {
          label: I18n.getText("sales.commission-rate"),
          value: item.commission_rate + "%"
        },
        {
          label: I18n.getText("sales.fee-discount-promotion"),
          value: item.output_tags
        }
      ]
    };
    return (
      <div>
        <div className={styles.back}>
          <LocaleLink to={"/sales"}>
            <Icon
              name={lang === "ar" ? "fwd-arrow" : "back-arrow"}
              className={styles.backArrow}
            />
          </LocaleLink>
          {I18n.getText("sales.details")}&nbsp;- {item.item_nr}
        </div>

        <ItemGlobalCard item={item} />

        <div className={styles.toggleCtr}>
          <ToggleButton
            toggleBtn={this.tabToggle}
            toggleItems={[
              I18n.getText("sales.sale-overview", {}, "Sale Overview"),
              I18n.getText("sales.payment-history", {}, "Payment History")
            ]}
            selected={this.state.view}
          />
        </div>
        {this.state.view === 2 ? (
          <PaymentHistory statements={statements} currencyCode={currencyCode} />
        ) : (
          <SalesOverview
            subheader={I18n.getText("sales.expected-payment")}
            pendingItem={pendingItem}
            saleData={saleData}
            commissionData={commissionData}
            currencyCode={currencyCode}
            penaltyData={item.sla_code === "legacy" ? undefined : penaltyData}
          />
        )}
      </div>
    );
  }
}

export default SalesDetails;



// WEBPACK FOOTER //
// ./src/components/sales/salesDetails/SalesDetails.js